/**
 * This is a collection of generated controllers for tracking click on elements. controllerDefs is the configuration,
 * where the key will end up as the controller name. Use the analytics(...), eventCollector(...) and trackOnNextPage(...)
 * functions to create a configuration for the controller. Object.assign is an ES2015 function to merge multiple objects
 * into one.
 *
 * See https://github.schibsted.io/finn/finn-analytics-js for definition of the event object keys
 */

const controllerDefs = {
    trackMap: eventCollector('show-interest.map.click', 'USER'),
    trackNeighborhood: eventCollector(
        'show-interest.neighborhood.click',
        'USER'
    ),
    trackFinanceLink: Object.assign(
        eventCollector('show-interest.finance-link.click', 'USER'),
        analytics('show-interest.finance-link.click', 'start')
    ),
    trackInsuranceLink: eventCollector(
        'show-interest.insurance-link.click',
        'USER'
    ),
    trackPengerCarloan: Object.assign(
        eventCollector('show-interest.penger-carloan-link.click', 'USER'),
        analytics('show-interest.penger-carloan-link.click', 'start')
    ),
    trackUsedCarGuaranteeLink: Object.assign(
        eventCollector('show-interest.car-guarantee.click', 'USER'),
        analytics('show-interest.car-guarantee.click', 'start')
    ),
    trackGetProspectus: Object.assign(
        analytics(
            'show-interest.get-realestate-brochure.click',
            'start,ltp',
            'effect'
        ),
        eventCollector('show-interest.get-realestate-brochure.click', 'USER')
    ),
    trackPlaceBid: Object.assign(
        analytics('offer.place-bid.click', 'start,ltp', 'effect'),
        eventCollector('offer.place-bid', 'USER')
    ),
    trackAddToCalendar: Object.assign(
        analytics('show-interest.add-to-calendar.click', 'start,ltp', 'effect'),
        eventCollector('show-interest.add-to-calendar.click', 'USER')
    ),
    trackApplyForJobExternalLink: Object.assign(
        analytics('contact.apply-for-position.click', 'ltp', 'effect'),
        eventCollector('contact.apply-for-position', 'USER'),
        pulse({
            type: 'Apply',
            object: {
                type: 'Job',
                name: 'Apply for a job',
            },
        })
    ),
    trackApplyForJobInternalLink: Object.assign(
        analytics('contact.apply-for-position.click', 'start', 'effect'),
        eventCollector('contact.apply-for-position', 'USER'),
        pulse({
            type: 'Apply',
            object: {
                type: 'Job',
                name: 'Apply for a job',
            },
        })
    ),
    trackShowPhoneNumberClick: Object.assign(
        analytics('contact.show-phone.click', 'start', 'effect'),
        eventCollector('contact.show-phone.click', 'USER'),
        pulse({
            type: 'Show',
            object: {
                type: 'PhoneContact',
                name: 'Show Phone',
                inReplyTo: {
                    type: 'ClassifiedAd',
                },
            },
        }),
        adwordsConversion('AW-1050677447/X9IKCO6OlncQx6GA9QM')
    ),
    trackShowPhoneNumberShow: Object.assign(
        analytics('contact.show-phone.show', 'start,success', 'effect'),
        pulse({
            type: 'Show',
            object: {
                type: 'PhoneContact',
                name: 'Show Phone',
                inReplyTo: {
                    type: 'ClassifiedAd',
                },
            },
        }),
        adwordsConversion('AW-1050677447/X9IKCO6OlncQx6GA9QM')
    ),
    trackEdialogChat: analytics(
        'contact.chat.click',
        'start,success',
        'effect'
    ),
    trackShowInterestWebpage: Object.assign(
        analytics(
            'show-interest.go-to-webpage.website',
            'start,success',
            'effect'
        ),
        pulse({
            type: 'Show',
            object: {
                type: 'Organization',
                name: 'Show Organization',
            },
        })
    ),
    trackShowInterestWebstore: Object.assign(
        analytics(
            'show-interest.go-to-webpage.webstore',
            'start,success',
            'effect'
        ),
        pulse({
            type: 'Show',
            object: {
                type: 'Organization',
                name: 'Show Organization',
            },
        })
    ),
    trackShowInterestWebPageLogo: Object.assign(
        analytics(
            'show-interest.go-to-webpage-via-logo.website',
            'start,success',
            'effect'
        ),
        pulse({
            type: 'Show',
            object: {
                type: 'Organization',
                name: 'Show Organization',
            },
        })
    ),
    trackShareTipAFriend: Object.assign(
        analytics('share.tip-a-friend.click', 'start', 'activity'),
        eventCollector('share.tip-a-friend', 'USER'),
        pulse({
            type: 'Share',
            object: {
                type: 'ClassifiedAd',
            },
        })
    ),
    trackShareOnFacebook: Object.assign(
        analytics('share.share-facebook.click', 'start,ltp', 'activity'),
        eventCollector('share.share-facebook', 'USER')
    ),
    trackShareOnTwitter: Object.assign(
        analytics('share.share-twitter.click', 'start,ltp', 'activity'),
        eventCollector('share.share-twitter', 'USER')
    ),
    trackFollowCompany: Object.assign(
        analytics('connect.follow-company.click', 'start,success', 'activity'),
        eventCollector('connect.follow-company', 'USER'),
        pulse({
            type: 'Follow',
            object: {
                type: 'Organization',
                name: 'Follow company',
            },
        })
    ),
    trackUnfollowCompany: Object.assign(
        analytics('connect.unfollow-company.click', 'start,success'),
        pulse({
            type: 'Unfollow',
            object: {
                type: 'Organization',
                name: 'Unfollow company',
            },
        })
    ),
    trackUnfollowCompanyForm: Object.assign(
        trackOnNextPage(),
        analytics('connect.unfollow-company.click', 'start,success'),
        pulse({
            type: 'Unfollow',
            object: {
                type: 'Organization',
                name: 'Unfollow company',
            },
        })
    ),
    trackShowCompanyProfile: Object.assign(
        analytics('show-interest.visit-company-profile', 'start,success'),
        eventCollector('show-interest.visit-company-profile.click', 'USER')
    ),
    trackSendMessage: Object.assign(
        trackOnNextPage(),
        analytics('contact.send-message.click', 'start', 'effect'),
        eventCollector('contact.send-message.click', 'USER'),
        pulse({
            type: 'Engagement',
            action: 'Click',
            object: {
                type: 'UIElement',
                id: 'send-melding',
                name: 'Send melding',
            },
            target: {
                type: 'ClassifiedAd',
            },
        })
    ),
    trackSendSMS: Object.assign(
        analytics('contact.send-sms.click', 'start,ltp', 'effect'),
        pulse({
            type: 'Send',
            object: {
                type: 'Message',
                id: 0,
                name: 'Send Message',
                inReplyTo: {
                    type: 'ClassifiedAd',
                },
            },
        })
    ),
    trackCallContact: Object.assign(
        analytics('contact.call.click', 'start,ltp', 'effect'),
        pulse({
            type: 'Contact',
            object: {
                type: 'PhoneContact',
                name: 'Contact Seller',
                inReplyTo: {
                    type: 'ClassifiedAd',
                },
            },
        })
    ),
    trackRealestateLivvinClick: Object.assign(
        analytics('navigation.go-to-livvin.click', 'start,ltp')
    ),
    trackCustomerLink: Object.assign(
        analytics('other.customer-link.click', 'start,success'),
        eventCollector('other.customer-link.click', 'USER')
    ),
    trackExtendedProfileLink: analytics(
        'other.extended-profile-link.click',
        'start,success'
    ),
    trackExtendedProfileLinkActionExternal: analytics(
        'other.extended-profile-action-link.click',
        'start,success'
    ),
    trackExtendedProfileLinkActionInternal: Object.assign(
        trackOnNextPage(),
        analytics('other.extended-profile-action-link.click', 'start,success')
    ),
    trackExtendedProfileLinkExtraBranding: analytics(
        'other.extended-profile-extra-branding-link.click',
        'start,success'
    ),
    trackMoreAdsFromThisOrganizationLink: Object.assign(
        trackOnNextPage(),
        analytics(
            'show-interest.more-ads-from-this-organization-link.click',
            'start,success'
        ),
        eventCollector(
            'show-interest.more-ads-from-this-organization-link.click',
            'USER'
        ),
        pulse({
            type: 'Show',
            object: {
                type: 'Listing',
                name: 'Show Listings from Seller',
            },
        })
    ),
    trackEditProfileLink: Object.assign(
        trackOnNextPage(),
        analytics('administrate.click-edit-profile-link.click', 'start')
    ),
    trackCustomLinksVeteran: Object.assign(
        trackOnNextPage(),
        analytics('search.custom_link_veteran.click', 'start')
    ),
    trackCustomLinksElbil: Object.assign(
        trackOnNextPage(),
        analytics('search.custom_link_elbil.click', 'start')
    ),
    trackCustomLinksTruck: Object.assign(
        trackOnNextPage(),
        analytics('search.custom_link_truck.click', 'start')
    ),
    trackCustomLinksStudioApartment: Object.assign(
        trackOnNextPage(),
        analytics('search.custom_link_studio.click', 'start')
    ),
    trackSeeMoreSameCarClick: Object.assign(
        trackOnNextPage(),
        analytics('navigation.same-car-link.click', 'start')
    ),
    trackSeeMoreSamePriceClick: Object.assign(
        trackOnNextPage(),
        analytics('navigation.same-price-link.click', 'start')
    ),
    trackSeeMoreSameSpecsClick: Object.assign(
        trackOnNextPage(),
        analytics('navigation.same-specs-link.click', 'start')
    ),
    trackVerifyUserClick: Object.assign(
        trackOnNextPage(),
        analytics('profile.verify-user.click', 'start')
    ),
    trackVerifyUserConfirm: Object.assign(
        trackOnNextPage(),
        analytics('profile.verify-user.confirm', 'start')
    ),
    trackVerifyUserAcceptForMessaging: Object.assign(
        trackOnNextPage(),
        analytics('contact.verify-user-to-contact.accept', 'start,ltp')
    ),
    trackVerifyUserDeclineForMessaging: Object.assign(
        trackOnNextPage(),
        analytics('contact.verify-user-to-contact.decline', 'start,success')
    ),
    trackAdPagingNext: Object.assign(
        trackOnNextPage(),
        analytics('search.go-to-next-ad', 'start,success')
    ),
    trackAdPagingPrev: Object.assign(
        trackOnNextPage(),
        analytics('search.go-to-prev-ad', 'start,success')
    ),
    trackCrumbTrailMarket: Object.assign(
        trackOnNextPage(),
        analytics('navigation.crumbtrail.level_1_market', 'start,success')
    ),
    trackCrumbTrailVertical: Object.assign(
        trackOnNextPage(),
        analytics('navigation.crumbtrail.level_2_vertical', 'start,success')
    ),
    trackCrumbTrailAttribute1: Object.assign(
        trackOnNextPage(),
        analytics('navigation.crumbtrail.level_3', 'start,success')
    ),
    trackCrumbTrailAttribute2: Object.assign(
        trackOnNextPage(),
        analytics('navigation.crumbtrail.level_4', 'start,success')
    ),
    trackCrumbTrailAttribute3: Object.assign(
        trackOnNextPage(),
        analytics('navigation.crumbtrail.level_5', 'start,success')
    ),
    trackReadMoreClick: Object.assign(
        analytics('show-interest.read-more', 'start,success'),
        eventCollector('show-interest.read-more.click', 'USER')
    ),
    trackReportAdClick: analytics('review.report-ad.click', 'start'),
    trackSurveyClick: analytics('other.take-survey.click', 'start'),
    trackAdvertiserWebClick: eventCollector('LOG_ADVERTISER_WEB_VIEWED', 'AD'),
    trackApplyForJobClick: eventCollector('LOG_JOB_ONLINE_APPLICATION', 'AD'),
    trackExtendedProfileButtonClick: eventCollector(
        'LOG_EXTENDED_PROFILE_BUTTON',
        'AD'
    ),
    trackExtendedProfileLinkClick: eventCollector(
        'LOG_EXTENDED_PROFILE_LINK',
        'AD'
    ),
    trackCarConditionLink: analytics(
        'navigation.car-condition-link.click',
        'start,ltp'
    ),
    trackSwiftCourtButtonClick: analytics(
        'contact.create-purchase-agreement.click',
        'start,ltp',
        'effect'
    ),
    trackClaimRightsClick: analytics(
        'show-interest.view-claim-rights.click',
        'success'
    ),
    trackConditionReportClick: analytics(
        'show-interest.view-assessment-report.click',
        'success'
    ),
    trackNafTestClick: analytics(
        'show-interest.view-naf-test.click',
        'success'
    ),
    trackPremiumProgramClick: analytics(
        'show-interest.view-warranties.click',
        'success'
    ),
    trackBuyersGuideClick: analytics(
        'show-interest.view-buyers-guide.click',
        'success'
    ),
    trackWarrantyGuideClick: analytics(
        'show-interest.view-warranty-guide.click',
        'success'
    ),
    trackSafetyElementswarrantyTab: analytics(
        'show-interest.view-safety-elements-warrantyTab.click',
        'success'
    ),
    trackSafetyElementsconditionTab: analytics(
        'show-interest.view-safety-elements-conditionTab.click',
        'success'
    ),
    trackSafetyElementsserviceTab: analytics(
        'show-interest.view-safety-elements-serviceTab.click',
        'success'
    ),
    trackSafetyElementsexchangePolicyTab: analytics(
        'show-interest.view-safety-elements-exchangePolicyTab.click',
        'success'
    ),
    trackSafetyElementsclaim2Tab: analytics(
        'show-interest.view-safety-elements-claim2Tab.click',
        'success'
    ),
    trackSafetyElementsclaim5Tab: analytics(
        'show-interest.view-safety-elements-claim5Tab.click',
        'success'
    ),
    trackSafetyElementstradeOrgTab: analytics(
        'show-interest.view-safety-elements-tradeOrgTab.click',
        'success'
    ),
    trackSafetyElementspremiumTab: analytics(
        'show-interest.view-safety-elements-premiumTab.click',
        'success'
    ),
    trackToggleMap: analytics('show-interest.show-map.click', 'success'),
    trackSelectRatee: analytics(
        'review.give-review.select-ratee',
        'start',
        'activity'
    ),
    trackStatisticsView: analytics('other.load-statistics-module.done'),
    trackUsedCarGuaranteeShown: analytics('show-interest.car-guarantee.shown'),
    trackEditAdClick: Object.assign(
        trackOnNextPage(),
        analytics('navigation.edit-ad-in-ad-admin.click', 'start,success')
    ),
    trackStartClick: Object.assign(
        trackOnNextPage(),
        analytics('navigation.show-in-list-in-ad-admin.click', 'start,success')
    ),
    trackDeleteClick: Object.assign(
        trackOnNextPage(),
        analytics('navigation.delete-ad-in-ad-admin.click', 'start,success')
    ),
    trackMarkAsSoldClick: Object.assign(
        trackOnNextPage(),
        analytics('navigation.mark-as-sold-in-ad-admin.click', 'start,success')
    ),
    trackCarBuyerContract: analytics(
        'show-interest.create-purchase-agreement-from-info-page.click',
        'start,success'
    ),
};

/**
 * Event configuration for Adobe Analytics
 * @param {string} analyticsName
 * @param {string} [eventFlags]
 * @param {string} [kpi]
 * @returns {Object} Event configuration for Analytics configuration
 */
function analytics(analyticsName, eventFlags, kpi) {
    return {
        analytics: { analyticsName, eventFlags, kpi },
    };
}

/**
 * Event configuration for Event-collector
 * @param {string} ecCategory
 * @param {string} ecType
 * @param {Object} [eventData]
 * @returns {Object} Event configuration for Event-collector
 */
function eventCollector(ecCategory, ecType, eventData) {
    return {
        ec: { ecCategory, ecType, eventData },
    };
}

/**
 * Event configuration for SPT Pulse SDK
 * @param {Object} eventData Event definition according to the Pulse Event Schema.
 * @returns {Object} Event configuration for SPT Pulse SDK
 */
function pulse(eventData) {
    return {
        pulse: eventData,
    };
}

function adwordsConversion(sendTo) {
    return {
        adwordsConversion: { sendTo },
    };
}

/**
 * Event configruation to delay tracking to the next mfinn-page (trackLater)
 * @param {boolean} [trackLater=true]
 * @returns {Object} Event configuration with trackLater enabled/disabled
 */
function trackOnNextPage(trackLater) {
    return {
        trackLater: trackLater !== false,
    };
}

function makeTrackingController(controllerName, controllerDef) {
    return {
        name: controllerName,
        dependencies: ['$element', 'trackingservice'],
        callable(ele, trackingService) {
            ele.addEventListener('click', () => {
                const { analytics, ec, adwordsConversion } = controllerDef;
                if (!analytics && !ec && !adwordsConversion) {
                    throw Error(`${controllerName} has an invalid config`);
                }
                const eventObject = Object.assign({}, analytics, ec);
                if (controllerDef.trackLater) {
                    trackingService.trackLaterObj(eventObject);
                } else {
                    trackingService.trackEventObject(eventObject);
                }
                if (typeof gtag === 'function' && adwordsConversion) {
                    window.gtag('event', 'conversion', {
                        // eslint-disable-next-line
                        send_to: adwordsConversion.sendTo
                    });
                }
            });

            // Stop-gap solution to handle migration of click events to new Pulse tracking SDK.
            setupPulseEventTracking();

            function setupPulseEventTracking() {
                const { pulse, trackLater } = controllerDef;
                if (!pulse) {
                    return;
                }
                if (pulse && !pulse.type && !pulse.object) {
                    throw Error(
                        `${controllerName} has an invalid Pulse config`
                    );
                }
                trackingService.getApi(api => {
                    const context = api.prepareContext().context;
                    const finnkode = context.finnkode;
                    const category = context.category;
                    const title = document.title;
                    const { object } = pulse;
                    if (object.type === 'ClassifiedAd') {
                        object.id = finnkode;
                        object.contentId = finnkode;
                        object.category = category;
                        object.name = title;
                    }
                    const { inReplyTo } = object;
                    if (inReplyTo && inReplyTo.type === 'ClassifiedAd') {
                        inReplyTo.id = finnkode;
                        inReplyTo.contentId = finnkode;
                        inReplyTo.category = category;
                        inReplyTo.name = title;
                    }
                    const { target } = pulse;
                    if (target && target.type === 'ClassifiedAd') {
                        target.id = finnkode;
                        target.contentId = finnkode;
                        target.category = category;
                        target.name = title;
                    }
                    ele.addEventListener('click', () => {
                        if (trackLater) {
                            trackingService.trackLaterObj({ pulse });
                        } else {
                            trackingService.trackEventObject({ pulse });
                        }
                    });
                });
            }
        },
    };
}

const controllers = Object.keys(
    controllerDefs
).reduce((result, controllerName) => {
    result[controllerName] = makeTrackingController(
        controllerName,
        controllerDefs[controllerName]
    );
    return result;
}, {});

export default controllers;



// WEBPACK FOOTER //
// ./controllers/clickTrackers.js